export default __webpack_public_path__ + "images/D8.348d029.png";